<template>
    <div>
        <div
            v-for="(v, i) in listOfValues"
            :key="i"
        >
            {{v}}
        </div>
        <div
            v-if="showButton"
            class="button is-small"
            @click="toggleShowMore($event)"
        >
            {{buttonLabel}}
        </div>
    </div>
</template>

<script>
import ListLimitMixin from '../mixins/ListLimitMixin';
export default {
    name : "JsonListDisplay",
    mixins : [ListLimitMixin],
    beforeMount () {
        if(this.value) {
            this.parsedValues = JSON.parse(this.value);
        }
    },
}
</script>

<style scoped>
</style>
